import { useLanguage } from "../context/LanguageContext";
import { Button } from "./ui/button";

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <div className="fixed top-6 right-6 z-50">
      <Button
        data-testid="language-toggle"
        variant="outline"
        size="sm"
        onClick={toggleLanguage}
        className="bg-white/80 backdrop-blur-sm border-slate-200 hover:bg-white hover:border-sky-400 transition-all duration-300 shadow-sm text-lg px-4"
      >
        {language === 'no' ? '🇬🇧' : '🇳🇴'}
      </Button>
    </div>
  );
};

export default LanguageToggle;
